import { Box, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import { WWW_BASE_URL } from '../../../App'
import GlobalSnackbarNotifier from '../../shared/components/ui-widgets/GlobalSnackbarNotifier'
import LoginComponent from '../components/LoginComponent'

const AuthLoginPage: React.FC = () => {
  return (
    <>
      <GlobalSnackbarNotifier/>
      <Grid container justifyContent={'center'} alignItems={'center'} sx={{ pt: 10 }}>
        <Grid item lg={4}>
          <Link href={WWW_BASE_URL} sx={{ display: 'block', width: '100%', textAlign: 'center' }}>
            <Box component={'img'} sx={{ width: 240 }} src="/icons/Sun-Exchange-Grey-Orange.png"
                 alt="Sun Exchange Logo"/>
          </Link>
          <LoginComponent/>
        </Grid>
      </Grid>
      <Grid container justifyContent={'center'} alignItems={'center'} sx={{ pt: 10 }}>
        <Grid item lg={4}>
          <Typography variant="body1" align="center">
            If you have any questions please contact us at&nbsp;
            <Link href={'mailto:enquiries@thesunexchange.com'}
                  underline={'hover'}
                  variant={'body1'}
                  sx={{}}>
              enquiries@thesunexchange.com
            </Link>
          </Typography>
        </Grid>

      </Grid>
    </>
  )
}

export default AuthLoginPage
